module.exports = __webpack_public_path__ + "img/40_38_032_190.227c8e07.jpg";